module.exports = __webpack_public_path__ + "img/product-details-2.bc0146fa.svg";